import React from 'react';
import { ArrowRight, ChevronRight } from 'lucide-react';
import { HERO } from '../constants';
import { useLanguage } from '../LanguageContext';

const HERO_IMAGE_URL = 'https://images.unsplash.com/photo-1622675363311-3e1904dc1885?crop=entropy&cs=srgb&fm=jpg&q=85&w=900';

export default function Hero() {
  const { lang }  = useLanguage();
  const hero      = HERO[lang];
  const { float } = hero;

  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="pb-hero" id="accueil" data-testid="pb-hero">
      <div className="pb-container pb-hero-inner">
        <div className="pb-hero-grid">

          {/* ── Colonne texte ─────────────────────── */}
          <div>
            <div className="pb-label pb-hero-tag" data-testid="pb-hero-tag">
              {hero.tag}
            </div>

            <h1 className="pb-hero-title-h1 pb-hero-title" data-testid="pb-hero-h1">
              {hero.title1}
              <span className="pb-accent">{hero.title2}</span>
            </h1>

            <p className="pb-hero-subtitle pb-hero-sub">
              {hero.subtitle}
            </p>

            <div className="pb-hero-actions pb-hero-btns">
              <button
                className="pb-btn-primary"
                onClick={() => scrollTo('#fonctionnalites')}
                data-testid="pb-hero-cta-primary"
              >
                {hero.ctaPrimary}
                <ChevronRight size={16} />
              </button>
              <button
                className="pb-btn-outline"
                onClick={() => window.dispatchEvent(new CustomEvent('openDemoModal'))}
                data-testid="pb-hero-cta-secondary"
              >
                {hero.ctaSecondary}
                <ArrowRight size={16} />
              </button>
            </div>

            {/* Indicateurs de confiance */}
            <div className="pb-hero-trust-row pb-hero-trust">
              {hero.trust.map((item, i) => (
                <React.Fragment key={item}>
                  {i > 0 && <div className="pb-trust-divider" />}
                  <div className="pb-trust-item">
                    <span className="pb-trust-dot" />
                    {item}
                  </div>
                </React.Fragment>
              ))}
            </div>
          </div>

          {/* ── Colonne photo + cartes flottantes ─── */}
          <div className="pb-hero-photo-side pb-hero-visual">
            <div className="pb-hero-photo-frame">

              <img
                src={HERO_IMAGE_URL}
                alt={hero.imgAlt}
                className="pb-hero-photo"
                loading="eager"
              />
              <div className="pb-hero-photo-overlay" />

              {/* Carte flottante — stats */}
              <div className="pb-hero-float-stats" data-testid="pb-hero-float-stats">
                <div className="pb-float-stat-value">{float.statsValue}</div>
                <div className="pb-float-stat-label">{float.statsLabel}</div>
                <div className="pb-float-stat-trend">
                  <span className="pb-float-trend-dot" />
                  {float.statsTrend}
                </div>
              </div>

              {/* Carte flottante — activité */}
              <div className="pb-hero-float-notif" data-testid="pb-hero-float-notif">
                <div style={{ fontSize: 9, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.4)', marginBottom: 8 }}>
                  {float.activityTitle}
                </div>
                {float.activity.map((item, i) => (
                  <div key={i} className="pb-notif-row">
                    <span className="pb-notif-dot" style={{ background: i === 0 ? '#10B981' : i === 1 ? '#0055A4' : '#94A3B8' }} />
                    <span className="pb-notif-text">{item.text}</span>
                    <span className="pb-notif-badge">{item.time}</span>
                  </div>
                ))}
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
